<template>
  <button
    class="uppercase tracking-wider font-medium group p-3 appear bbutton duration-200 inline-flex items-center cursor-pointer rounded-xl disabled:cursor-not-allowed disabled:!opacity-50"
    :class="theme" :disabled="disabled">
    <span class="min-w-26 md:min-w-32 lg:min-w-40 text-left inline-flex items-center">
      <slot name="default">Submit</slot>
    </span>
    <Icon :name="icon" class="w-8 h-8 text-xl group-hover:animate-pulse ml-auto icon" />
  </button>
</template>

<script setup lang="ts">
import type { Button, Theme } from '~/types'

interface Props extends Button {
  inline?: boolean
  theme?: Theme | 'red'
  text?: string
  disabled?: boolean
  icon?: string
}

const { icon = 'material-symbols:double-arrow' } = defineProps<Props>()
</script>

<style lang="css" scoped>
@reference "@/assets/css/main.css";

.bbutton {
  @apply bg-primary text-white hover:bg-white hover:text-primary-dark font-semibold;
}

.red.bbutton {
  @apply bg-red-600 text-white hover:bg-red-700 hover:text-white;
}

.light.bbutton,
.secondary.bbutton {
  @apply bg-primary text-white hover:bg-primary-dark hover:text-white;
}

.light.bbutton.secondary {
  @apply bg-zinc-200 text-zinc-600 hover:bg-white hover:text-primary;
}

.light.bbutton .icon {
  @apply text-primary-dark group-hover:text-primary-green
}

.light.bbutton.secondary .icon {
  @apply text-primary group-hover:text-zinc-600;
}

.dark.bbutton {
  @apply bg-primary-green text-white hover:bg-primary;
}

.white.bbutton,
.dark.secondary.bbutton {
  @apply bg-primary-dark text-zinc-100 hover:bg-white hover:text-primary-dark;
}
</style>
